import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';
// import { SuccessImage } from 'assets/svg';

import { Content } from './styled';

const { Title } = Typography;

const MessageChangePassword: FC = () => {
  // translation
  const { t } = useTranslation();
  // router
  const navigate = useNavigate();

  return (
    <Content>
      {/* <SuccessImage style={{ marginBottom: 24 }} /> */}
      <Title level={2} style={{ marginBottom: 24 }}>
        {t('auth.success_message_title')}
      </Title>
      <Button
        type="primary"
        shape="round"
        size="large"
        block
        onClick={() => navigate('/login')}
      >
        {t('auth.success_message_button')}
      </Button>
    </Content>
  );
};

export default MessageChangePassword;
